var _circle, _circle2, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _path2, _g2, _path3, _path4, _g3, _rect, _path5, _path6, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalGainIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6724_113086)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2955,
    cy: 8.03199,
    r: 3.17725,
    fill: "#FCB75B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6724_113086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 4,
    width: 7,
    height: 8
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2955,
    cy: 8.03199,
    r: 3.17725,
    fill: "#FCB75B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6724_113086)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.4137,
    cy: 8.032,
    r: 3.17725,
    fill: "#FED159"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.3747,
    y1: 1.75697,
    x2: 26.3747,
    y2: 3.18673,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26.3747,
    y1: 12.8773,
    x2: 26.3747,
    y2: 14.307,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5703,
    y1: 8.11135,
    x2: 31.1406,
    y2: 8.11135,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 21.45,
    y1: 8.11135,
    x2: 20.0202,
    y2: 8.11135,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6498,
    y1: 3.53872,
    x2: 22.6608,
    y2: 4.54972,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 29.2968,
    y1: 11.7765,
    x2: 30.3078,
    y2: 12.7875,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 30.6823,
    y1: 3.65121,
    x2: 29.6713,
    y2: 4.66221,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 22.4448,
    y1: 11.889,
    x2: 21.4338,
    y2: 12.9,
    stroke: "#FED159",
    strokeWidth: 1.21795,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47677 36H37L29.6344 21.5468C28.0907 18.5176 23.9109 18.1446 21.8552 20.8526L15.5625 29.1419C15.3441 29.4296 14.9707 29.5523 14.6243 29.4503L11.0339 28.3932C9.20578 27.855 7.23493 28.497 6.07471 30.0088L1.47677 36Z",
    fill: "#8DBC42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6724_113086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 18,
    width: 40,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.1147H39.1304L29.0431 20.4885C27.3154 17.8122 23.4588 17.6529 21.5163 20.1776L16.1599 27.1393C15.9126 27.4607 15.4759 27.5685 15.1075 27.3991L10.8299 25.4323C8.64348 24.427 6.05159 25.2726 4.87871 27.374L0 36.1147Z",
    fill: "#8DBC42"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6724_113086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 36H40L30.4628 21.4869C29.4922 20.0098 27.3645 19.9052 26.2537 21.28L20.1764 28.8008C19.9369 29.0973 19.5321 29.2032 19.178 29.062L13.4875 26.7926C12.332 26.3318 11.0119 26.751 10.3339 27.794L5 36Z",
    fill: "#82B037"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2557 23.3715L4.3479 37.3045H29.5653L22.2454 23.7086C20.3585 20.2038 15.3998 20.0178 13.2557 23.3715Z",
    fill: "#99CC56"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6724_113086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 20,
    width: 26,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2557 23.3715L4.3479 37.3045H29.5653L22.2454 23.7086C20.3585 20.2038 15.3998 20.0178 13.2557 23.3715Z",
    fill: "#99CC56"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6724_113086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8243 23.9184L10 37.3045H34.0436L26.9226 24.078C24.9918 20.4917 19.8797 20.402 17.8243 23.9184Z",
    fill: "#90C649"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 40,
    height: 3,
    rx: 1.5,
    fill: "#B78046"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1481 32.5867C34.8556 31.3334 33.7313 30.3999 32.3889 30.3999C30.8241 30.3999 29.5556 31.6684 29.5556 33.2332C29.5556 33.2603 29.5559 33.2873 29.5567 33.3143C29.4087 33.2618 29.2493 33.2332 29.0833 33.2332C28.7205 33.2332 28.3895 33.3696 28.1389 33.594C27.9424 33.4181 27.6965 33.2963 27.4246 33.2518C27.1007 32.677 26.4846 32.2888 25.7778 32.2888C24.7346 32.2888 23.8889 33.1345 23.8889 34.1777H22.9444C22.4228 34.1777 22 34.6005 22 35.1221C22 35.6437 22.4228 36.0666 22.9444 36.0666H25.7778H27.1944H29.0833H32.3889H36.1667H38.0556C38.5772 36.0666 39 35.6437 39 35.1221C39 34.6005 38.5772 34.1777 38.0556 34.1777C38.0556 33.1345 37.2099 32.2888 36.1667 32.2888C35.7916 32.2888 35.442 32.3981 35.1481 32.5867Z",
    fill: "#98D647"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6724_113086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 30,
    width: 17,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1481 32.5867C34.8556 31.3334 33.7313 30.3999 32.3889 30.3999C30.8241 30.3999 29.5556 31.6684 29.5556 33.2332C29.5556 33.2603 29.5559 33.2873 29.5567 33.3143C29.4087 33.2618 29.2493 33.2332 29.0833 33.2332C28.7205 33.2332 28.3895 33.3696 28.1389 33.594C27.9424 33.4181 27.6965 33.2963 27.4246 33.2518C27.1007 32.677 26.4846 32.2888 25.7778 32.2888C24.7346 32.2888 23.8889 33.1345 23.8889 34.1777H22.9444C22.4228 34.1777 22 34.6005 22 35.1221C22 35.6437 22.4228 36.0666 22.9444 36.0666H25.7778H27.1944H29.0833H32.3889H36.1667H38.0556C38.5772 36.0666 39 35.6437 39 35.1221C39 34.6005 38.5772 34.1777 38.0556 34.1777C38.0556 33.1345 37.2099 32.2888 36.1667 32.2888C35.7916 32.2888 35.442 32.3981 35.1481 32.5867Z",
    fill: "#A7E950"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6724_113086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.037 32.5866C36.7445 31.3334 35.6202 30.3999 34.2778 30.3999C32.713 30.3999 31.4445 31.6684 31.4445 33.2332C31.4445 33.2603 31.4449 33.2873 31.4456 33.3142C31.2976 33.2617 31.1383 33.2332 30.9722 33.2332C30.6094 33.2332 30.2784 33.3696 30.0278 33.5939C29.8313 33.418 29.5854 33.2962 29.3135 33.2518C28.9896 32.677 28.3735 32.2887 27.6667 32.2887C26.6235 32.2887 25.7778 33.1344 25.7778 34.1776H24.8334C24.3118 34.1776 23.8889 34.6005 23.8889 35.1221C23.8889 35.6437 24.3118 36.0665 24.8334 36.0665H27.6667H29.0834H30.9722H34.2778H38.0556H39.9445C40.4661 36.0665 40.8889 35.6437 40.8889 35.1221C40.8889 34.6005 40.4661 34.1776 39.9445 34.1776C39.9445 33.1344 39.0988 32.2887 38.0556 32.2887C37.6805 32.2887 37.3309 32.3981 37.037 32.5866Z",
    fill: "#A7E950"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6724_113086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalGainIcon);
export default __webpack_public_path__ + "static/media/vertical-gain-icon.0f0c017e666a7df4d803b1a5db0aad11.svg";
export { ForwardRef as ReactComponent };